import { Inject, Injectable, Optional } from '@angular/core';
import { MatDateFormats, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { Store } from '@ngxs/store';
import moment from 'moment';
import { LocalizationState } from '../store/localization.state';

@Injectable()
export class NimbusDateAdapter extends NativeDateAdapter {
  public constructor(
    @Optional() @Inject(MAT_DATE_LOCALE) matDateLocale: string,
    private readonly store: Store,
  ) {
    super(matDateLocale);
  }

  public format(date: Date, displayFormat: object): string {
    const result = moment(date)
      .locale(this.store.selectSnapshot(LocalizationState.selectedDateFormat))
      .format(displayFormat as unknown as string);

    return result;
  }
}

export const NimbusDateFormats: MatDateFormats = {
  parse: {
    dateInput: 'L',
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
